export const DEFAULT_SEARCH_PAGE_SIZE = 20;
export const DEFAULT_SEARCH_PAGE_NUM = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_LOAD_MORE = 10;

export const ROLES = ['technician', 'manager'];

export const Role = {
    TECHNICIAN: 'technician',
    MANAGER: 'manager',
    OWNER: 'owner',
};

/** Organization-scoped role from /api/users/sync or /api/me */
export const OrgRole = {
    OWNER: 'owner',
    TECHNICIAN: 'technician',
};

/** Keycloak realm role for platform-wide admin actions */
export const PlatformRole = {
    ADMIN: 'platform-admin',
};

export const isOrgOwner = (role?: string | null) =>
    role === OrgRole.OWNER || role === Role.MANAGER;

export const isPlatformAdmin = (roles?: string[] | null) =>
    Array.isArray(roles) && roles.some(r => r === PlatformRole.ADMIN);

export const ROLE_MAPPING = {
    technician: 'Technician',
    manager: 'Manager',
};

export const ROLES_OPTIONS = [
    { value: 'technician', label: 'Technician' },
    { value: 'manager', label: 'Manager' },
];

export const AUTH_ERROR = 'auth/invalid-credential';

/**
 * SignalR hub base URL.
 *
 * ALWAYS derived from REACT_APP_API_BASE_URL — the hub lives on the API
 * server, not the frontend host. The old fallback to
 * `window.location.origin` was dangerous: when the env var was missing
 * (build misconfiguration, SSR, etc.) it resolved to the static-hosting
 * origin (`auto.featurespace.cloud`) instead of the API
 * (`autoapi.featurespace.cloud`), and nginx returned 405 Method Not
 * Allowed on POST /notification/negotiate, which SignalR retried in a
 * tight loop via `withAutomaticReconnect()`.
 *
 * No env var → no hub. The `startSignalRConnection()` call site already
 * handles a null URL by skipping the connection; a hard error here is
 * better than silently hitting the wrong host forever.
 */
function getSignalRHubBase(): string | null {
    if (typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL) {
        return process.env.REACT_APP_API_BASE_URL;
    }
    // eslint-disable-next-line no-console
    console.error(
        '[signalr] REACT_APP_API_BASE_URL is not set — SignalR will not connect. ' +
            'Check that the correct .env file was used at build time.'
    );
    return null;
}

const hubBase = getSignalRHubBase();
export const SIGNALR_URL = hubBase ? `${hubBase}/notification` : '';
